<template>
  <div class="video-description" @click="onClickTimestamp">
    <div>公開日：{{ video.createDate }}</div>
    <div v-html="replaceHTMLSellerInfo(parsedDesc)"></div>
  </div>
</template>
<script>
import { replaceHTMLSellerInfo, convertTimestampsToLinks } from '@/common/utility'

export default {
  props: {
    video: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    parsedDesc () {
      const raw = this.video.desc || ''
      return convertTimestampsToLinks(raw)
    }
  },
  methods: {
    replaceHTMLSellerInfo,
    convertTimestampsToLinks,
    onClickTimestamp (e) {
      const link = e.target.closest('.timestamp-link')
      if (!link) return

      e.preventDefault()
      const seconds = Number(link.dataset.seek)
      this.$emit('seekTo', seconds)
    }

  }
}
</script>
<style scoped>
.video-description {
  background-color: #0000000d;
  border-radius: 8px;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/video/components/VideoDescription.vue